import React, { ReactNode } from "react"
import {
  Flex, Heading, LayoutProps, SpaceProps, Text,
} from "@chakra-ui/react"
import Button from "components/Buttons/Button"
import { ModalName } from "sharedTypes"
import { useIntercom } from "react-use-intercom"
import useModal from "services/useModal"
import Icon from "components/elements/Icon"
import useCurrentPlanType from "utilities/useCurrentPlanType"
import AlertBox, { AlertBoxType } from "./AlertBox/AlertBox"

interface Props {
  text: string|ReactNode
  title?: string
  noBorder?: boolean;
  mb?: SpaceProps["marginBottom"]
  maxW?: LayoutProps["maxWidth"]
  defaultSelectedPlan?: string
  continueOnTheCurrentScreen?: boolean
}

const UpgradeAlert = ({
  title, text, noBorder = false, mb, maxW, defaultSelectedPlan, continueOnTheCurrentScreen,
}: Props) => {
  const { show: showIntercom } = useIntercom()
  const showModal = useModal()
  const { onLargestPlan } = useCurrentPlanType()

  const handleClick = () => (
    onLargestPlan ? showIntercom() : showModal(
      ModalName.Upgrade, { defaultSelectedPlan, continueOnTheCurrentScreen },
    ))
  const buttonText = onLargestPlan ? "Contact Us" : "Upgrade"
  const color = "blue.500"

  if (noBorder) {
    return (
      <Flex justify="flex-start" align="center" mb={mb}>
        <Icon icon="info" color={color} mr={1} />
        {title && <Heading>{title}</Heading>}
        <Text textColor={color} fontWeight="bold" fontSize="md" mr={3}>{text}</Text>
        <Button
          size="xs"
          variant={noBorder ? "outline" : "solid"}
          color={color}
          onClick={handleClick}
        >{buttonText}
        </Button>
      </Flex>
    )
  }

  return (
    <AlertBox
      type={AlertBoxType.Upgrade}
      header={title}
      text={text}
      buttonText={buttonText}
      onClick={handleClick}
      mb={mb}
      maxW={maxW}
    />
  )
}

export default UpgradeAlert
